module.exports = __webpack_public_path__ + "img/attachment.0ca8d2c6.png";